/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuthorWithRelations } from '../../models/author-with-relations';

export interface EditorGetAuthor$Params {
  id: string;
}

export function editorGetAuthor(http: HttpClient, rootUrl: string, params: EditorGetAuthor$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthorWithRelations>> {
  const rb = new RequestBuilder(rootUrl, editorGetAuthor.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AuthorWithRelations>;
    })
  );
}

editorGetAuthor.PATH = '/editor/author';
